/**
 * Design-direction registry (TMS pattern): the discovery hypotheses travel
 * into the UI behind /designs, so the round's reasoning is reviewable in-app.
 * Round 1: 6a935de2516b0e4b3431df55 (closed) — winner VERDANT, ratified by
 * Agon 2026-08-30 over the panel's meridian-structure convergence.
 */
export interface DesignDirection {
  key: string
  name: string
  register: string
  hypothesis: string
  round: 1
  badge: 'winner · ratified' | 'structure donor' | 'discipline donor' | 'borrow-only'
  final: number
  galleryPath: string
}

export const DESIGN_DIRECTIONS: readonly DesignDirection[] = [
  {
    key: 'verdant',
    name: 'Verdant (control · mockup-native)',
    register: 'Warm-grey canvas, white cards, hairlines, serif display; aubergine = decided, mint = proposed',
    hypothesis: 'The deck’s own language survives contact with real density and stays AA once the inks are darkened.',
    round: 1,
    badge: 'winner · ratified',
    final: 63,
    galleryPath: '/design-discovery/design-directions/verdant/project-overview.html',
  },
  {
    key: 'meridian',
    name: 'Meridian (light mission-control)',
    register: 'Dark aubergine rail, numbered lifecycle stepper, agent-accountability furniture',
    hypothesis: 'A mission-control skeleton makes the trust model legible: every run carries status, time and a way into the log.',
    round: 1,
    badge: 'structure donor',
    final: 65,
    galleryPath: '/design-discovery/design-directions/meridian/project-overview.html',
  },
  {
    key: 'ledger',
    name: 'Ledger (Rhea-tuned dense pro-tool)',
    register: 'Mono/tabular figure contract, dot+label statuses, measured density budgets',
    hypothesis: 'Discipline over decoration: every hard constraint cleared by measurement.',
    round: 1,
    badge: 'discipline donor',
    final: 68,
    galleryPath: '/design-discovery/design-directions/ledger/project-overview.html',
  },
  {
    key: 'aurora',
    name: 'Aurora (Luma-tuned soft luminous)',
    register: 'Radial washes, generous tiles, people-first warmth',
    hypothesis: 'Warmth earns adoption — rejected as foundation; its exception treatment and decision chips survive as borrows.',
    round: 1,
    badge: 'borrow-only',
    final: 43,
    galleryPath: '/design-discovery/design-directions/aurora/project-overview.html',
  },
] as const
